namespace GeniuzPOS.Purchase {
    export class PoPo06DtPendingCNforCnrtvColumns {
        static columnsKey = 'Purchase.PoPo06DtPendingCNforCnrtv';
    }
}
